import type { CashFlowType, Currency } from '../api/generated/client';

const formatAmountInternal = (value: number, showPlusMinus = false, showOnlyMinus = false) => {
    const amount = (Math.abs(value) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    let sign = '';
    if ((showOnlyMinus || showPlusMinus) && value < 0) {
        sign = '-';
    }
    if (showPlusMinus && value > 0) {
        sign = '+';
    }

    return { sign, amount };
};

export const formatAmount = (value: number, showPlusMinus = false, currency?: string, showOnlyMinus = false) => {
    const { sign, amount } = formatAmountInternal(value, showPlusMinus, showOnlyMinus);

    return [sign, amount, currency].filter((item) => !!item).join(' ');
};

export const formatAmountCurrencyFirst = (value: number, showPlusMinus = false, currency?: string, showOnlyMinus = false) => {
    const { sign, amount } = formatAmountInternal(value, showPlusMinus, showOnlyMinus);

    return !value ? '' : [currency, sign, amount].filter((item) => !!item).join(' ');
};

const liquidityTableAmountFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export const formatAmountCurrency = (value: number | null | undefined, currency: string) => {
    if (value == null || Number.isNaN(value)) return '';

    const cur = currency.trim();
    const formattedValue = `${value < 0 ? '-' : ''}${liquidityTableAmountFormatter.format(Math.abs(value))}`;

    return cur ? `${cur} ${formattedValue}` : formattedValue;
};

export const formatCashFlowAmount = (signedAmount: number, type?: CashFlowType, currency?: Currency, numberFormat = 'en-US') => {
    const formattedAmount = new Intl.NumberFormat(numberFormat).format(Math.abs(signedAmount));

    return type === 'INFLOW' ? `+ ${formattedAmount} ${currency}` : `- ${formattedAmount} ${currency}`;
};

export const formatNumberToAbsCompactNotation = (value?: number) => formatNumberToCompactNotation(value != null ? Math.abs(value) : value);

export const formatNumberToCompactNotation = (value?: number) =>
    value == null || isNaN(value)
        ? ''
        : Intl.NumberFormat('en-US', {
              notation: 'compact',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          }).format(value);
